import { Pipe, PipeTransform } from '@angular/core';
import { Defect } from '@jms/model';

@Pipe({ name: 'defectEntityName' })
export class DefectEntityNamePipe implements PipeTransform {

  transform(defect: Defect): string {

    if (!!defect?.workOrder?._id)
      return defect?.workOrder?.name;

    return defect?.job?.name;

  }

}
